import Spinner from '@/shared/Spinner'
import Container from '@mui/material/Container'
import Dialog from '@mui/material/Dialog'
import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import PDFViewerContainer from './PDFViewerContainer'
import CloseIcon from '@mui/icons-material/Close'

const ReportPreview = ({ onClose, content, document }) => {
  const renderContent = () => {
    if (content) return content

    return document ? (
      <Container
        maxWidth={false}
        sx={{
          height: '100%',
          padding: 0,
          paddingLeft: '0 !important',
          paddingRight: '0 !important',
        }}
      >
        <PDFViewerContainer document={document} />
      </Container>
    ) : (
      <Stack
        sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
      >
        <Spinner />
      </Stack>
    )
  }

  return (
    <Dialog maxWidth={false} open={true} onClose={onClose}>
      <Stack
        spacing={1}
        sx={{
          overflow: 'hidden',
          height: '90vh',
          maxHeight: '90vh',
          aspectRatio: '1.2',
          p: 2,
        }}
      >
        <Stack direction="row" justifyContent="flex-end" mb={1}>
          <IconButton
            edge="end"
            color="#979797"
            onClick={() => {
              onClose()
            }}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Stack>
        <Stack style={{ flex: 1, overflowY: 'hidden' }}>{renderContent()}</Stack>
      </Stack>
    </Dialog>
  )
}

export default ReportPreview
